export default __webpack_public_path__ + "static/media/Jnnce.f4f590e6.jpg";